import { tv } from 'tailwind-variants'

export const emptyStateVariants = tv({
  slots: {
    container: 'flex flex-col justify-center items-center content-center space-x-micro',
    titleStyle: 'text-h4 font-bold',
    messageStyle: 'text-sub text-secondary-medium text-center',
    button: 'mt-centi mb-peta',
    icon: 'text-primary-medium text-mega'
  }
})
